import { render, staticRenderFns } from "./XYParameters.vue?vue&type=template&id=9276a1ec&scoped=true"
import script from "./XYParameters.vue?vue&type=script&lang=js"
export * from "./XYParameters.vue?vue&type=script&lang=js"
import style0 from "./XYParameters.vue?vue&type=style&index=0&id=9276a1ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9276a1ec",
  null
  
)

export default component.exports